'use client';

import { useEffect } from 'react';

const TRANSLATIONS: Record<string, string> = {
  'Messages': '\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F',
  'Send': '\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C',
  'Enter a message...': '\u041D\u0430\u043F\u0438\u0441\u0430\u0442\u044C \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435...',
  'Enter a message\u2026': '\u041D\u0430\u043F\u0438\u0441\u0430\u0442\u044C \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435...',
  'Join': '\u041F\u0440\u0438\u0441\u043E\u0435\u0434\u0438\u043D\u0438\u0442\u044C\u0441\u044F',
  'Your name': '\u0412\u0430\u0448\u0435 \u0438\u043C\u044F',
  'Username': '\u0412\u0430\u0448\u0435 \u0438\u043C\u044F',
  'Settings': '\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438',
  'Camera': '\u041A\u0430\u043C\u0435\u0440\u0430',
  'Microphone': '\u041C\u0438\u043A\u0440\u043E\u0444\u043E\u043D',
  'Speaker & Headphones': '\u0414\u0438\u043D\u0430\u043C\u0438\u043A\u0438 \u0438 \u043D\u0430\u0443\u0448\u043D\u0438\u043A\u0438',
  'Audio Output': '\u0410\u0443\u0434\u0438\u043E\u0432\u044B\u0445\u043E\u0434',
  'Media Devices': '\u0423\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430',
  'Recording': '\u0417\u0430\u043F\u0438\u0441\u044C',
  'Close': '\u0417\u0430\u043A\u0440\u044B\u0442\u044C',
  'Background Effects': '\u042D\u0444\u0444\u0435\u043A\u0442\u044B \u0444\u043E\u043D\u0430',
  'None': '\u0411\u0435\u0437 \u0444\u043E\u043D\u0430',
  'Blur': '\u0420\u0430\u0437\u043C\u044B\u0442\u0438\u0435',
  'Connecting...': '\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435...',
  'Reconnecting...': '\u041F\u0435\u0440\u0435\u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435...',
  'People': '\u0423\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0438',
  'No messages yet': '\u041D\u0435\u0442 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0439',
  'Share screen': '\u042D\u043A\u0440\u0430\u043D',
  'Stop sharing': '\u041E\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C',
  'Share Screen': '\u042D\u043A\u0440\u0430\u043D',
  'Start Recording': '\u041D\u0430\u0447\u0430\u0442\u044C \u0437\u0430\u043F\u0438\u0441\u044C',
  'Stop Recording': '\u041E\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u0437\u0430\u043F\u0438\u0441\u044C',
  'This meeting is being recorded': '\u0412\u0441\u0442\u0440\u0435\u0447\u0430 \u0437\u0430\u043F\u0438\u0441\u044B\u0432\u0430\u0435\u0442\u0441\u044F',
  'Leave': '\u0412\u044B\u0439\u0442\u0438',
  'Disconnect': '\u041E\u0442\u043A\u043B\u044E\u0447\u0438\u0442\u044C\u0441\u044F',
  'You': '\u0412\u044B',
  'Mute': '\u0412\u044B\u043A\u043B. \u043C\u0438\u043A\u0440\u043E\u0444\u043E\u043D',
  'Unmute': '\u0412\u043A\u043B. \u043C\u0438\u043A\u0440\u043E\u0444\u043E\u043D',
  'Enable Camera': '\u0412\u043A\u043B. \u043A\u0430\u043C\u0435\u0440\u0443',
  'Disable Camera': '\u0412\u044B\u043A\u043B. \u043A\u0430\u043C\u0435\u0440\u0443',
  'Chat': '\u0427\u0430\u0442',
  'Toggle Microphone': '\u041C\u0438\u043A\u0440\u043E\u0444\u043E\u043D',
  'Toggle Camera': '\u041A\u0430\u043C\u0435\u0440\u0430',
  'Share Screen (Experimental)': '\u042D\u043A\u0440\u0430\u043D',
  'Select a device': '\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E',
  'No Audio': '\u0411\u0435\u0437 \u0437\u0432\u0443\u043A\u0430',
  'No Video': '\u0411\u0435\u0437 \u0432\u0438\u0434\u0435\u043E',
  'Participants': '\u0423\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0438',
  'More options': '\u0415\u0449\u0451',
  'Layout': '\u0420\u0430\u0441\u043A\u043B\u0430\u0434\u043A\u0430',
  'Grid': '\u0421\u0435\u0442\u043A\u0430',
  'Speaker': '\u0414\u043E\u043A\u043B\u0430\u0434\u0447\u0438\u043A',
  'Focus': '\u0424\u043E\u043A\u0443\u0441',
  'Pin': '\u0417\u0430\u043A\u0440\u0435\u043F\u0438\u0442\u044C',
  'Unpin': '\u041E\u0442\u043A\u0440\u0435\u043F\u0438\u0442\u044C',
  'Maximize': '\u0420\u0430\u0437\u0432\u0435\u0440\u043D\u0443\u0442\u044C',
  'Minimize': '\u0421\u0432\u0435\u0440\u043D\u0443\u0442\u044C',
  'E2EE': '\u0428\u0438\u0444\u0440\u043E\u0432\u0430\u043D\u0438\u0435',
  'Enable E2EE': '\u0412\u043A\u043B. \u0448\u0438\u0444\u0440\u043E\u0432\u0430\u043D\u0438\u0435',
  'Disable E2EE': '\u0412\u044B\u043A\u043B. \u0448\u0438\u0444\u0440\u043E\u0432\u0430\u043D\u0438\u0435',
  'Start Audio': '\u0412\u043A\u043B. \u0437\u0432\u0443\u043A',
};

const PLACEHOLDER_TRANSLATIONS: Record<string, string> = {
  'Enter a message...': '\u041D\u0430\u043F\u0438\u0441\u0430\u0442\u044C \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435...',
  'Enter a message\u2026': '\u041D\u0430\u043F\u0438\u0441\u0430\u0442\u044C \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435...',
  'Your name': '\u0412\u0430\u0448\u0435 \u0438\u043C\u044F',
  'Username': '\u0412\u0430\u0448\u0435 \u0438\u043C\u044F',
};

let isProcessing = false;

function translateNode(node: Node) {
  if (node.nodeType === Node.TEXT_NODE && node.textContent) {
    const trimmed = node.textContent.trim();
    if (TRANSLATIONS[trimmed]) {
      node.textContent = node.textContent.replace(trimmed, TRANSLATIONS[trimmed]);
    }
  }
  if (node instanceof HTMLInputElement || node instanceof HTMLTextAreaElement) {
    const ph = node.placeholder;
    if (ph && PLACEHOLDER_TRANSLATIONS[ph]) {
      node.placeholder = PLACEHOLDER_TRANSLATIONS[ph];
    }
  }
  if (node instanceof HTMLElement) {
    const title = node.getAttribute('title');
    if (title && TRANSLATIONS[title]) {
      node.setAttribute('title', TRANSLATIONS[title]);
    }
    const ariaLabel = node.getAttribute('aria-label');
    if (ariaLabel && TRANSLATIONS[ariaLabel]) {
      node.setAttribute('aria-label', TRANSLATIONS[ariaLabel]);
    }
  }
}

function translateAll(root: Element) {
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT);
  let node: Node | null = walker.currentNode;
  while (node) {
    translateNode(node);
    node = walker.nextNode();
  }
}

function cleanupPreJoin() {
  // Remove text nodes from circular buttons (mic/camera) so icons center properly
  document.querySelectorAll('.lk-prejoin .lk-button-group .lk-button').forEach((btn) => {
    btn.childNodes.forEach((child) => {
      if (child.nodeType === Node.TEXT_NODE && child.textContent && child.textContent.trim() !== '') {
        child.textContent = '';
      }
    });
  });
  // Hide E2EE button
  document.querySelectorAll('.lk-prejoin .lk-username-container button:not(.lk-join-button)').forEach((btn) => {
    const el = btn as HTMLElement;
    if (el.style.display !== 'none') {
      el.style.display = 'none';
    }
  });
}

function cleanupControlBar() {
  // Remove text nodes from control bar buttons (CSS sets font-size:0 but text nodes can still affect layout)
  document.querySelectorAll('.lk-control-bar .lk-button, .lk-control-bar button').forEach((btn) => {
    btn.childNodes.forEach((child) => {
      if (child.nodeType === Node.TEXT_NODE && child.textContent && child.textContent.trim() !== '') {
        child.textContent = '';
      }
    });
  });
}

export function RussianTranslator() {
  useEffect(() => {
    translateAll(document.body);
    cleanupPreJoin();
    cleanupControlBar();

    const observer = new MutationObserver(() => {
      if (isProcessing) return;
      isProcessing = true;
      requestAnimationFrame(() => {
        translateAll(document.body);
        cleanupPreJoin();
        cleanupControlBar();
        isProcessing = false;
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    const interval = setInterval(() => {
      translateAll(document.body);
      cleanupPreJoin();
      cleanupControlBar();
    }, 3000);

    return () => {
      observer.disconnect();
      clearInterval(interval);
    };
  }, []);

  return null;
}
